import { Button } from "../../ui-library/Button/Button.tsx";
import styles from "./FilterButton.module.css";

export const FilterButton = (props: {
  onClick: () => void;
  disabled?: boolean;
}) => (
  <Button
    onClick={props.onClick}
    disabled={props.disabled}
    variant={"transparent"}
    className={styles.FilterButton}
  >
    <FilterIcon /> Filters
  </Button>
);

const FilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    style={{ margin: "-8px 0 -6px -8px" }}
  >
    <rect x="5" y="7" width="14" height="2" fill="currentColor" />
    <rect x="8" y="11" width="8" height="2" fill="currentColor" />
    <rect x="10.0508" y="15" width="4" height="2" fill="currentColor" />
  </svg>
);
